module.exports = __webpack_public_path__ + "static/img/class.b7ad509.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/class.png
// module id = Q/No
// module chunks = 1